import axios from "axios";
import { HttpClient, RequestParams } from "../../utils/api/http-client";
import IBaseListingResponse from "../../utils/api/base-listing-response";
import { IDriverClassificationQuery } from "../../models/driver-classification/query";
import { IDriverClassification } from "../../models/driver-classification/response";
import {
  ICreateDriverClassification,
  IExportDriverClassificationExcel,
  IUpdateDriverClassification,
} from "../../models/driver-classification/request";
import { ACCESS_TOKEN, LANGUAGE_CODE } from "../../utils/helpers/constants";

class DriverClassificationService<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  getAllDriverClassifications = (
    query: IDriverClassificationQuery,
    params?: RequestParams
  ) =>
    this.http.request<IBaseListingResponse<IDriverClassification>>({
      path: `/driver-classifications`,
      method: "GET",
      query,
      ...params,
    });

  getDriverClassification = (id: number, params?: RequestParams) =>
    this.http.request<IDriverClassification>({
      path: `/driver-classifications/${id}`,
      method: "GET",
      ...params,
    });

  createDriverClassification = (
    data: ICreateDriverClassification,
    params?: RequestParams
  ) =>
    this.http.request<IDriverClassification>({
      path: "/driver-classifications",
      method: "POST",
      body: data,
      ...params,
    });

  updateDriverClassification = (
    id: number,
    data: IUpdateDriverClassification,
    params?: RequestParams
  ) =>
    this.http.request<IDriverClassification>({
      path: `/driver-classifications/${id}`,
      method: "PUT",
      body: data,
      ...params,
    });

  deleteDriverClassification = (id: number, params?: RequestParams) =>
    this.http.request<IDriverClassification>({
      path: `/driver-classifications/${id}`,
      method: "DELETE",
      ...params,
    });

  exportExcel = (
    data: IExportDriverClassificationExcel,
    query: IDriverClassificationQuery
  ) =>
    axios.post(
      `${process.env.REACT_APP_BASE_API_URL}/driver-classifications/export`,
      data,
      {
        headers: {
          authorization: `Bearer ${
            localStorage.getItem(ACCESS_TOKEN) ||
            sessionStorage.getItem(ACCESS_TOKEN)
          }`,
          "Content-Type": "application/json",
          "accept-language": `${
            localStorage.getItem(LANGUAGE_CODE) ??
            process.env.REACT_APP_DEFAULT_LANGUAGE
          }`,
        },
        params: query,
        responseType: "arraybuffer",
      }
    );
}

export default DriverClassificationService;
